import Seo from "@/components/Seo";
import ContactForm from "@/components/ContactForm";

const Contact = () => (
  <div data-testid="contact-page">
    <Seo
      title="Contact Fast Alu | Demande de devis ou urgence"
      description="Contactez Fast Alu pour une urgence ou un devis. Formulaire multi-étapes et réponse rapide."
    />
    <section className="bg-brand-blue/5" data-testid="contact-hero">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <h1 className="font-heading text-4xl uppercase" data-testid="contact-title">
          Contact & devis
        </h1>
        <p className="text-brand-ink/70 mt-4" data-testid="contact-subtitle">
          Remplissez le formulaire multi-étapes ou appelez-nous directement pour une intervention urgente.
        </p>
      </div>
    </section>

    <section className="max-w-6xl mx-auto px-6 py-16 grid lg:grid-cols-[1.2fr_0.8fr] gap-10">
      <ContactForm />
      <div className="space-y-6" data-testid="contact-infos">
        <div className="border border-brand-blue/15 p-6 rounded-sm bg-white">
          <h2 className="font-heading text-2xl uppercase" data-testid="contact-info-title">
            Coordonnées directes
          </h2>
          <p className="text-brand-ink/70 mt-2" data-testid="contact-info-text">
            Nous répondons rapidement aux urgences et aux demandes de devis.
          </p>
          <div className="mt-4 space-y-2">
            <a href="tel:0184160307" className="block font-semibold" data-testid="contact-info-phone">
              01 84 16 03 07
            </a>
            <a
              href="mailto:contact@fast-alu.com"
              className="block text-brand-ink/70"
              data-testid="contact-info-email"
            >
              contact@fast-alu.com
            </a>
            <span className="block text-brand-ink/70" data-testid="contact-info-site">
              fast-alu.fr
            </span>
          </div>
        </div>
        <div className="border border-brand-blue/15 p-6 rounded-sm bg-white" data-testid="contact-info-urgent">
          <h3 className="font-heading text-xl uppercase" data-testid="contact-urgent-title">
            Urgence 24h/24
          </h3>
          <p className="text-brand-ink/70 mt-2" data-testid="contact-urgent-text">
            Intervention rapide sur rideaux métalliques, portes blindées et sécurisation.
          </p>
          <a
            href="tel:0184160307"
            className="inline-flex mt-4 bg-brand-red text-white px-5 py-2 rounded-sm uppercase text-xs font-bold"
            data-testid="contact-urgent-call"
          >
            Appelez maintenant
          </a>
        </div>
      </div>
    </section>
  </div>
);

export default Contact;
